import React from 'react';
import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import intl from 'react-intl-universal';

import { supportsWebapp, isAppleMobileDevice, isAndroidMobileDevice } from 'utils/browser';
import { redirectToWebapp, redirectToPlayStore, redirectToLauncher, redirectToAppleStore } from 'utils/navigation';
import { useStyles } from '../ContactForm.Styles';
import { defaultButtonProps } from '../DefaultProps';

const webappSupported = supportsWebapp();
const appleStoreSupported = isAppleMobileDevice();
const playStoreSupported = isAndroidMobileDevice();

interface Props {
  email: string;
  password: string;
}

export default function RedirectWidget(props: Props) {
  const classes = useStyles();
  return (
    <Box>
      <h2 className={classes.heading}>{intl.get('components.DownloadApp.downloadCaption')}</h2>
      <Box mt={2}>
        {appleStoreSupported && (
          <Button {...defaultButtonProps} className={classes.continueButton} onClick={redirectToAppleStore}>
            {intl.get('components.RedirectWidget.getStartedButton')}
          </Button>
        )}
        {playStoreSupported && (
          <Button {...defaultButtonProps} className={classes.continueButton} onClick={redirectToPlayStore}>
            {intl.get('components.RedirectWidget.getStartedButton')}
          </Button>
        )}
        {!appleStoreSupported && !playStoreSupported && webappSupported && (
          <Button
            {...defaultButtonProps}
            className={classes.continueButton}
            onClick={() => redirectToWebapp(props.email, props.password)}
          >
            {intl.get('components.RedirectWidget.getStartedButton')}
          </Button>
        )}
        {!appleStoreSupported && !playStoreSupported && !webappSupported && (
          <Button {...defaultButtonProps} className={classes.continueButton} onClick={redirectToLauncher}>
            {intl.get('components.RedirectWidget.getStartedButton')}
          </Button>
        )}
      </Box>
    </Box>
  );
}
